import React from "react";
import { Box, Button, Paper, Grid, Stack, Typography } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import { PricingTier } from "./SubscriptionTable";
import { styled } from "@mui/material/styles";
import jwtAxios from "../../utils/jwtAxios";

interface SubscriptionCardProps {
  currentSubscription: string;
  features?: string[];
}

const SubscriptionCard: React.FC<SubscriptionCardProps> = ({
  currentSubscription,
  features,
}) => {

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body1,
    padding: theme.spacing(3),
    textAlign: 'center',
    width: "340px",
    height: "480px",
  }));

  const customTier: PricingTier = {
    id: "tier_enterprise",
    name: "Launch Partner Special",
    price: 5000,
  };

  const featureList = ["60 Day Free Trial", "No Credit Card Required", "10% Discount Coupon", "20% Commission", "10 Experiences", "1,000 Beacons", "50,000 Complimentary Pings per Year", "Analytics", "Referrals"];

  const manageSubscription = () => {

    const apiUrl = "api/subscription/trial";

    jwtAxios.post(apiUrl)
        .then(response => {
            window.location.href = response.data.url;
        })
        .catch(error => {
            console.error('There was a problem with the API request:', error);
        });
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
      <Item sx={currentSubscription === customTier.id ? {border: "solid 2px", borderImageSource: "linear-gradient(to bottom, rgba(255, 103, 31, 1) 50%, hsl(20, 100%, 50%) 70%)", borderImageSlice: 1}  : {}}>
        <Typography variant="h5" mb={2} fontWeight={600} fontSize={24}>
          {customTier.name}
        </Typography>
        <Typography variant="h3" mr={50} fontSize={24} fontWeight={500} sx={{ textDecorationLine: 'line-through' }}>$7,500</Typography>
        <Box mb={6} borderBottom="solid">
          <Stack alignItems="center" direction="row" gap={2} justifyContent="center" mb={10}>
            <Typography variant="h3" fontSize={44} fontWeight={500}>${customTier.price.toLocaleString() ?? ""}</Typography>
            <Typography variant="body1">per year*</Typography>
          </Stack>
        </Box>
        <Box mb={0} minHeight={170} textAlign="left">
          {featureList.map((feature, index) => (
            <Stack key={index} alignItems="center" direction="row" gap={2} marginLeft={5}>
              <DoneIcon sx={{ color: "green" }} />
              <Typography variant="body1" fontSize={14} fontWeight={500}>{feature}</Typography>
            </Stack>
          ))}
        </Box>
        <Typography sx={{ fontSize: 10, fontWeight: 400 }}>*Introductory pricing.  See Terms and Conditions.</Typography>
        <Button
          variant="contained"
          sx={{ paddingX: 4, width: "90%" }}
          onClick={() =>
            manageSubscription()
          }
          disabled={currentSubscription === customTier.id}
        >
          Choose Subscription
        </Button>
      </Item>
    </Box>
  );
};

export default SubscriptionCard;
